"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sansSerifBold = {
    0x20: [0, 0, .25],
    0x21: [.694, 0, .367],
    0x22: [.694, -0.442, .558],
    0x23: [.694, .193, .917],
    0x24: [.75, .056, .55],
    0x25: [.75, .056, 1.029],
    0x26: [.716, .022, .831],
    0x27: [.694, -0.442, .306],
    0x28: [.75, .249, .428],
    0x29: [.75, .25, .428],
    0x2A: [.75, -0.293, .55],
    0x2B: [.617, .116, .856],
    0x2C: [.146, .106, .306],
    0x2D: [.273, -0.186, .367],
    0x2E: [.146, 0, .306],
    0x2F: [.75, .249, .55],
    0x30: [.715, .022, .55],
    0x31: [.716, 0, .55],
    0x32: [.716, 0, .55],
    0x33: [.716, .022, .55],
    0x34: [.694, 0, .55],
    0x35: [.694, .022, .55],
    0x36: [.716, .022, .55],
    0x37: [.695, .011, .55],
    0x38: [.715, .022, .55],
    0x39: [.716, .022, .55],
    0x3A: [.458, 0, .306],
    0x3B: [.458, .106, .306],
    0x3D: [.407, -0.094, .856],
    0x3F: [.705, 0, .519],
    0x40: [.704, .011, .733],
    0x41: [.694, 0, .733],
    0x42: [.694, 0, .733],
    0x43: [.704, .011, .703],
    0x44: [.694, 0, .794],
    0x45: [.691, 0, .642],
    0x46: [.691, 0, .611],
    0x47: [.705, .011, .733],
    0x48: [.694, 0, .794],
    0x49: [.694, 0, .331],
    0x4A: [.694, .022, .519],
    0x4B: [.694, 0, .764],
    0x4C: [.694, 0, .581],
    0x4D: [.694, 0, .978],
    0x4E: [.694, 0, .794],
    0x4F: [.716, .022, .794],
    0x50: [.694, 0, .703],
    0x51: [.716, .106, .794],
    0x52: [.694, 0, .703],
    0x53: [.716, .022, .611],
    0x54: [.688, 0, .733],
    0x55: [.694, .022, .764],
    0x56: [.694, 0, .733],
    0x57: [.694, 0, 1.039],
    0x58: [.694, 0, .733],
    0x59: [.694, 0, .733],
    0x5A: [.694, 0, .672],
    0x5B: [.75, .25, .343],
    0x5D: [.75, .25, .343],
    0x5E: [.694, -0.537, .55],
    0x5F: [-0.023, .11, .55],
    0x61: [.475, .011, .525],
    0x62: [.694, .01, .561],
    0x63: [.475, .011, .489],
    0x64: [.694, .011, .561],
    0x65: [.474, .01, .511],
    0x66: [.705, 0, .336, { ic: .045 }],
    0x67: [.469, .206, .55],
    0x68: [.694, 0, .561],
    0x69: [.695, 0, .256],
    0x6A: [.695, .205, .286],
    0x6B: [.694, 0, .531],
    0x6C: [.694, 0, .256],
    0x6D: [.469, 0, .867],
    0x6E: [.468, 0, .561],
    0x6F: [.474, .011, .55],
    0x70: [.469, .194, .561],
    0x71: [.469, .194, .561],
    0x72: [.469, 0, .372],
    0x73: [.474, .01, .422],
    0x74: [.589, .01, .404],
    0x75: [.458, .011, .561],
    0x76: [.458, 0, .5],
    0x77: [.458, 0, .744],
    0x78: [.458, 0, .5],
    0x79: [.458, .205, .5],
    0x7A: [.458, 0, .476],
    0x7E: [.344, -0.198, .55],
    0xA0: [0, 0, .25],
    0x131: [.458, 0, .256],
    0x237: [.458, .205, .286],
    0x300: [.694, -0.537, 0],
    0x301: [.694, -0.537, 0],
    0x302: [.694, -0.537, 0],
    0x303: [.694, -0.548, 0],
    0x304: [.66, -0.56, 0],
    0x306: [.694, -0.552, 0],
    0x307: [.695, -0.596, 0],
    0x308: [.695, -0.595, 0],
    0x30A: [.694, -0.538, 0],
    0x30B: [.694, -0.537, 0],
    0x30C: [.657, -0.5, 0],
    0x391: [.694, 0, .733],
    0x392: [.694, 0, .733],
    0x393: [.691, 0, .581],
    0x394: [.694, 0, .917],
    0x395: [.691, 0, .642],
    0x396: [.694, 0, .672],
    0x397: [.694, 0, .794],
    0x398: [.716, .022, .856],
    0x399: [.694, 0, .331],
    0x39A: [.694, 0, .764],
    0x39B: [.694, 0, .672],
    0x39C: [.694, 0, .978],
    0x39D: [.694, 0, .794],
    0x39E: [.688, 0, .733],
    0x39F: [.716, .022, .794],
    0x3A0: [.691, 0, .794],
    0x3A1: [.694, 0, .703],
    0x3A2: [.716, .022, .856],
    0x3A3: [.694, 0, .794],
    0x3A4: [.688, 0, .733],
    0x3A5: [.715, 0, .856],
    0x3A6: [.694, 0, .794],
    0x3A7: [.694, 0, .733],
    0x3A8: [.694, 0, .856],
    0x3A9: [.716, 0, .794],
    0x3D2: [.715, 0, .856],
    0x3DC: [.691, 0, .611],
    0x2013: [.327, -0.24, .55],
    0x2014: [.327, -0.24, 1.1],
    0x2015: [.327, -0.24, 1.1],
    0x2017: [-0.023, .11, .55],
    0x2018: [.694, -0.443, .306],
    0x2019: [.694, -0.442, .306],
    0x201C: [.694, -0.443, .558],
    0x201D: [.694, -0.442, .558],
    0x2044: [.75, .249, .55],
    0x2206: [.694, 0, .917],
};
//# sourceMappingURL=sans-serif-bold.js.map